/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecipientCommentsWithDraftedAnswerCountQueryVariables = Types.Exact<{
  surveyContentType: Types.SurveyContentType;
}>;


export type RecipientCommentsWithDraftedAnswerCountQuery = { global: { id: string, recipientCommentsWithDraftedAnswerCount: number } };


export const RecipientCommentsWithDraftedAnswerCountDocument = gql`
    query RecipientCommentsWithDraftedAnswerCount($surveyContentType: SurveyContentType!) {
  global: getStatisticsGlobal(surveyContentType: $surveyContentType) {
    id
    recipientCommentsWithDraftedAnswerCount: number_of_recipient_comments(processing_status: draft)
  }
}
    `;

/**
 * __useRecipientCommentsWithDraftedAnswerCountQuery__
 *
 * To run a query within a React component, call `useRecipientCommentsWithDraftedAnswerCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientCommentsWithDraftedAnswerCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientCommentsWithDraftedAnswerCountQuery({
 *   variables: {
 *      surveyContentType: // value for 'surveyContentType'
 *   },
 * });
 */
export function useRecipientCommentsWithDraftedAnswerCountQuery(baseOptions: Apollo.QueryHookOptions<RecipientCommentsWithDraftedAnswerCountQuery, RecipientCommentsWithDraftedAnswerCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipientCommentsWithDraftedAnswerCountQuery, RecipientCommentsWithDraftedAnswerCountQueryVariables>(RecipientCommentsWithDraftedAnswerCountDocument, options);
      }
export function useRecipientCommentsWithDraftedAnswerCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipientCommentsWithDraftedAnswerCountQuery, RecipientCommentsWithDraftedAnswerCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipientCommentsWithDraftedAnswerCountQuery, RecipientCommentsWithDraftedAnswerCountQueryVariables>(RecipientCommentsWithDraftedAnswerCountDocument, options);
        }
export type RecipientCommentsWithDraftedAnswerCountQueryHookResult = ReturnType<typeof useRecipientCommentsWithDraftedAnswerCountQuery>;
export type RecipientCommentsWithDraftedAnswerCountLazyQueryHookResult = ReturnType<typeof useRecipientCommentsWithDraftedAnswerCountLazyQuery>;
export type RecipientCommentsWithDraftedAnswerCountQueryResult = Apollo.QueryResult<RecipientCommentsWithDraftedAnswerCountQuery, RecipientCommentsWithDraftedAnswerCountQueryVariables>;